import styled from 'styled-components';
import { InputSection } from '../formInput/DeclarationInput.styles';

export const CombinedFieldItems = styled(InputSection)`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;

    > * {
        flex: 1;
        min-width: 0;
    }
`;
